import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import cx from 'classnames';
import { getFlyingBetslipConfig } from 'helpers/prematch';

import { SiteConfigManager, useSportState } from '@atlas/core';
import { EmptyStateView, SimpleTournamentSkeleton } from '@atlas/ui';

import { useSimpleSearchState } from 'components/Search';
import SimplifiedViewLoader from 'src/components/Pages/Prematch/SimplifiedViewLoader';

const SimplifiedCategoriesLoader = ({ children }) => {
  const { isOpened } = useSimpleSearchState();

  const { error, initialized, loading } = useSportState();
  const { tournamentName } = useParams();

  const isEnableFavouritesInSimplified = SiteConfigManager.getConfig(
    'config.config.sportsbook.enableFavouritesInSimplified',
  );

  const layoutClassName = useMemo(
    () =>
      cx('layout-to-scroll', {
        'layout-to-scroll-with-padding': getFlyingBetslipConfig().hasExtended,
      }),
    [],
  );

  if (!initialized && loading) {
    return (
      <SimplifiedViewLoader>
        <SimpleTournamentSkeleton
          minimized={tournamentName}
          outcomesNumber={1}
          withFavorite={isEnableFavouritesInSimplified && tournamentName}
        />
      </SimplifiedViewLoader>
    );
  }

  if (error && !isOpened) {
    return (
      <div className={layoutClassName}>
        <EmptyStateView description="sportsbook_empty_description" title="sportsbook_no_events" />
      </div>
    );
  }

  return <div className={layoutClassName}>{children}</div>;
};

export default SimplifiedCategoriesLoader;
